import * as React from 'react';
import { Card } from 'primereact/card';

import { TabMenu } from 'primereact/tabmenu';
import { Container } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { GroupMemberHome } from './GroupMemberHome';
import { GroupMemberSavings } from './GroupMemberSavings';
import AddUpdateGroupMemberSavings from './AddUpdateGroupMemberSavings';
import { useEffect } from 'react';
import { setGroupMemberDetail } from '../../redux/actions/groupMemberDetailActions';
import { useDispatch } from 'react-redux';
import { GroupMemberTrainings } from './GroupMemberTrainings';
import AddUpdateGroupMemberTrainings from './AddUpdateGroupMemberTrainings';
import AddUpdateGroupMemberFeedbacks from './AddUpdateGroupMemberFeedbacks';
import { GroupMemberFeedbacks } from './GroupMemberFeedbacks';


export const GroupMemberNavigation = () => {
    const navigate = useNavigate();
    const { group_member_id } = useParams();

    const dispatch = useDispatch()

    const menuItems = [
        {
            label: 'Member Details', icon: 'pi pi-home',
            command: () => {
                navigate('/shgadmin/group_member/' + group_member_id + '/?page=home')
            }
        },
        {
            label: 'Saving & Credit', icon: 'pi pi-chart-line',
            command: () => {
                navigate('/shgadmin/group_member/' + group_member_id + '/?page=saving')
            }
        },
        {
            label: 'Training', icon: 'pi pi-list',
            command: () => {
                navigate('/shgadmin/group_member/' + group_member_id + '/?page=training')
            }
        },
        {
            label: 'Feedback', icon: 'pi pi-inbox',
            command: () => {
                navigate('/shgadmin/group_member/' + group_member_id + '/?page=feedback')
            }
        }
    ];

    const searchParams = new URLSearchParams(window.location.search)

    const currentPage = searchParams.get("page")
    const action = searchParams.get("action")

    useEffect(() => {
        return () => {
            dispatch(setGroupMemberDetail(null))
        }
    }, [])

    return (
        <Container fluid>
            <Card>
                <TabMenu model={menuItems} pt={{
                    action: {
                        style: {
                            textDecoration: "none",
                        },
                    }
                }} />
                {
                    currentPage === 'home' ?
                        <GroupMemberHome />
                    : currentPage === 'saving' ?
                        action === 'add' || action === 'update' ?
                            <AddUpdateGroupMemberSavings />
                        : <GroupMemberSavings />
                    : currentPage === 'training' ?
                        action === 'add' || action === 'update' ?
                            <AddUpdateGroupMemberTrainings />
                        : <GroupMemberTrainings />
                    : currentPage === 'feedback' ?
                        action === 'add' || action === 'update' ?
                            <AddUpdateGroupMemberFeedbacks />
                        : <GroupMemberFeedbacks />
                    : null
                }
            </Card>


        </Container >
    );
};
